export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f44870cef1cad911736625e3eb8ad4a857e6be7ee&name=fetchTypeahead!'